import axiosNew from '../../helpers/axios'

// GET USER
export const getUser = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const getUser = await axiosNew({
                url:
                    `users/${payload?.password ? 'set-password' : 'get'}/` +
                    payload?._id +
                    `${payload?.password ? `?setPassword=true` : ''}`,
                method: 'get',
            })
            resolve({ data: getUser?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// COUNT USERS
export const count = async (payload) => {
    const { search = '', filter = {} } = payload
    return new Promise(async (resolve) => {
        let newFilterValue = {
            isTalentUser: true,
        }

        Object.keys(filter).forEach((data) => {
            if (filter[data] !== '') {
                newFilterValue = { ...newFilterValue, [data]: filter[data] }
            } else {
                newFilterValue = { ...newFilterValue }
            }
        })
        try {
            let data = {
                filter: newFilterValue,
            }
            if (search?.length > 0) {
                data['search'] = {
                    name: payload?.search,
                    email: payload?.search,
                    phone: payload?.search,
                }
            }
            const count = await axiosNew({
                url: 'users/count',
                data,
            })
            resolve({ data: count?.data?.result ?? 0 })
        } catch (error) {
            resolve({ data: 0 })
        }
    })
}

// LIST USERS
export const read = (payload) => {
    const { search = '', skip = 0, limit = 0, filter = {} } = payload
    return new Promise(async (resolve) => {
        let newFilterValue = { isTalentUser: true }

        Object.keys(filter).forEach((data) => {
            if (filter[data] !== '') {
                newFilterValue = { ...newFilterValue, [data]: filter[data] }
            } else {
                newFilterValue = { ...newFilterValue }
            }
        })
        try {
            let data = {
                skip,
                filter: newFilterValue,
                limit,
                select: [
                    'name',
                    'email',
                    'employeeNumber',
                    'phone',
                    'countryCode',
                    'flag',
                    'address',
                    'employmentType',
                    'state',
                    'department',
                    'designation',
                    'emergencyName',
                    'emergencyPhone',
                    'notes',
                    'role',
                    'isActive',
                    'profilePicture',
                    'location',
                    'isOurUser',
                ],
                populate: {
                    name: [
                        {
                            path: 'role',
                            select: 'roleName',
                        },
                        {
                            path: 'designation',
                            select: 'name',
                        },
                        {
                            path: 'workspace',
                            select: 'domain logo companyName',
                        },
                    ],
                },
            }
            if (search?.length > 0) {
                data['search'] = {
                    name: search,
                    email: search,
                    phone: search,
                }
            }
            const users = await axiosNew({
                url: 'users/read',
                data,
            })
            resolve({
                data: users?.data?.result ?? [],
                isNext: users?.data?.isNext,
            })
        } catch (error) {
            resolve({ data: [] })
        }
    })
}

// USER LIST FOR CLIENT MODULE
export const userListForClient = async (payload = {}) => {
    const {
        skip = 0,
        filter = {},
        limit = 10,
        search = '',
        projectId = '',
        type,
    } = payload
    return new Promise(async (resolve) => {
        try {
            let data = {
                skip,
                filter,
                limit,
                projectId,
            }

            if (type) {
                data.type = type
            }

            // Add search if provided
            if (search?.length > 0) {
                data.search = search
            }

            const response = await axiosNew({
                url: 'support/user-list',
                method: 'POST',
                data,
            })
            resolve({
                data: response?.data?.result ?? response?.data?.data ?? [],
                isNext: response?.data?.isNext ?? false,
                skip: skip,
            })
        } catch (error) {
            resolve({
                data: [],
                isNext: false,
                skip: skip,
            })
        }
    })
}


export const AssigneeTaskUserListProject = async (payload = {}) => {
    const {
        skip = 0,
        filter = {},
        limit = 10,
        search = '',
        projectId = '',
        type,
    } = payload
    return new Promise(async (resolve) => {
        try {
            let data = {
                skip,
                filter,
                limit,
                projectId,
            }
            if (type) {
                data.type = type
            }

            // Add search if provided
            if (search?.length > 0) {
                data.search = search
            }

            const response = await axiosNew({
                url: 'support/task/assignee-list',
                method: 'POST',
                data,
            })
            resolve({
                data: response?.data?.result ?? response?.data?.data ?? [],
                isNext: response?.data?.isNext ?? false,
                skip: skip,
            })
        } catch (error) {
            resolve({
                data: [],
                isNext: false,
                skip: skip,
            })
        }
    })
}
// LIST ROLES
export const listRoles = async () => {
    return new Promise(async (resolve) => {
        try {
            let data = { select: ['roleName'] }
            const roleList = await axiosNew({
                url: 'role/list/',
                data,
            })
            resolve({ data: roleList?.data?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// ADD JIRA API TOKEN
export const apiAddJiraApiToken = async (userId, data) => {
    return new Promise(async (resolve) => {
        try {
            const create = await axiosNew({
                url: `users/update/${userId}`,
                data: { data },
            })
            resolve({ data: create?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
